import React, { useEffect, useState } from "react";
import FormFactory from "../../../../components/form-factory";
import { GroupProp } from "../../../../components/form-factory/utils/util";
import { FilterType } from "./type";
import * as S from "./styles";

type FiltersProps = {
  onChange?: (filters: FilterType) => void;
};

export const Filters = ({ onChange }: FiltersProps): JSX.Element => {
  const debounceRef = React.useRef<NodeJS.Timeout | null>(null);
  const firstRenderRef = React.useRef<boolean>(true);

  const [filters, setFilters] = useState<FilterType>({});

  useEffect(() => {
    if (firstRenderRef.current) {// Skip the first render
      firstRenderRef.current = false;
      return;
    }

    if (onChange) {
      onChange(filters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const fields: GroupProp[] = [{
    groupName: "FILTER",
    groupLabel: "",
    items: [
      {
        type: "text",
        name: "query",
        label: "Pesquisar",
        placeholder: "Digite aqui...",
        onChange: (value: string) => {
          if (debounceRef.current) {
            clearTimeout(debounceRef.current);
          }
          debounceRef.current = setTimeout(() => {
            setFilters((prev) => ({
              ...prev,
              query: value,
            }));
          }, 500);
        },
        col: {
          xs: 6,
          md: 6,
          lg: 3,
        },
      }
    ]
  }];

  return (
    <S.ContainerFilter>
      <FormFactory
        groups={fields}
        onSubmit={() => {
          console.log("submit form");
        }}
        backButton={{
          submit: "Voltar",
          submitting: "Voltando...",
          hide: true,
        }}
        button={{
          submit: "Salvar",
          submitting: "Salvando...",
          hide: true,
        }}
      />
    </S.ContainerFilter>
  );
};